import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomProductItemComponent} from './custom-product-item.component';
import {MediaModule, StarRatingModule} from '@spartacus/storefront';
import {CustomAddToCartModule} from '../../../../spartacus/custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module';
import {RouterModule} from '@angular/router';
import {I18nModule, UrlModule} from '@spartacus/core';
import {CustomStockNotificationModule} from '../../../../spartacus/custom/cms-components/product/custom-stock-notification/custom-stock-notification.module';
import {CustomProductTagsModule} from '../../../../spartacus/custom/cms-components/product/custom-product-tags/custom-product-tags.module';


@NgModule({
  declarations: [CustomProductItemComponent],
  exports: [
    CustomProductItemComponent
  ],
    imports: [
        CommonModule,
        MediaModule,
        CustomAddToCartModule,
        RouterModule,
        UrlModule,
        I18nModule,
        CustomStockNotificationModule,
        StarRatingModule,
        CustomProductTagsModule
    ]
})
export class CustomProductItemModule {
}
